(ns ncr.fragment.props.interval
  (:require
   ["date-fns" :as dfns]
   [clojure.string :as str]
   [tick.core :as t]
   [ncr.etc.pf :as pf]
   [ncr.fragment.props.date :as props-date]
   [uix.core.alpha :as uix]))

(defn- date-format [^js date]
  (props-date/to-string (t/date date)))

(defn- date->inst [date]
  (try
    (t/inst (t/at date "00:00"))
    (catch js/Error _ nil)))

(defn- str->date [date-str]
  (when-not (str/blank? date-str)
    (try
      (t/parse-date date-str props-date/formatter)
      (catch js/Error _ nil))))

(def date->str (comp date-format date->inst))

(defn in-days [{:keys [start-date end-date]}]
  (when-not (or (str/blank? start-date) (str/blank? end-date))
    (let [s (js/Date. (t/at start-date "00:00"))
          e (js/Date. (t/at end-date "23:59"))]
      (dfns/formatDistanceStrict s e #js {:unit "day" :roundingMethod "ceil"}))))

(defn days-count [interval]
  (some-> interval in-days))

(defn input [{:keys [id value on-change on-key-down add-from? add-count?]}]
  (let [{:keys [start-date end-date]} value
        change! (fn [k v] (on-change (assoc value k v)))
        start-str (uix/state "")
        end-str (uix/state "")
        start (when-not (str/blank? start-date)
                (date->str start-date))
        end (when-not (str/blank? end-date)
              (date->str end-date))
        date-parse (comp date->inst str->date)]
    [pf/c-split {:class :ncr-c-property-interval :has-gutter true}
     [pf/c-split-item
      [pf/c-date-picker
       {:id id
        :value (or start @start-str "")
        :date-parse date-parse
        :date-format date-format
        :placeholder "Start date"
        :append-to #(.-body js/document)
        :on-key-down (when on-key-down (partial on-key-down :from))
        :validators #js [(fn [data]
                           (when (and (some? end-date) (t/> (t/date data) end-date))
                             "Must not be greater than end date"))]
        :on-change (fn [_event v _date]
                     (when-let [d (str->date v)]
                       (on-change
                         (merge {:start-date d}
                           (when (nil? end-date)
                             {:end-date (t/>> d (t/new-period 1 :days))}))))
                     (reset! start-str v))
        :on-blur (fn [_event v _date] (change! :start-date (str->date v)))}]]
     [pf/c-split-item {:class :ncr-c-property-interval__label} \u2014]
     [pf/c-split-item
      [pf/c-date-picker
       {:value       (or end @end-str "")
        :date-parse  date-parse
        :date-format date-format
        :range-start (date->inst start-date)
        :placeholder "End date"
        :append-to #(.-body js/document)
        :on-key-down (when on-key-down (partial on-key-down :to))
        :validators #js [(fn [date]
                           (when (and (some? start-date) (t/< (t/date date) start-date))
                             "Must not be less than start date"))]
        :on-change (fn [_event v _date]
                     (when-let [d (str->date v)]
                       (on-change
                         (merge {:end-date d}
                           (when (nil? start-date)
                             {:start-date (t/<< d (t/new-period 1 :days))}))))
                     (reset! end-str v))
        :on-blur (fn [_event v _date]
                   (change! :end-date (str->date v)))}]]
     (when-let [days (and add-count? (days-count value))]
       [pf/c-split-item {:class [:ncr-c-property-interval__label :ncr-c-property-interval__label-count]} days])]))

(defn ->str [{:keys [start-date end-date]}]
  (let [start (props-date/to-string start-date)
        end (when-not (str/blank? end-date) (props-date/to-string end-date))]
    (if-not (str/blank? end)
      (str start " — " end)
      (str "From " start))))

(defn new-interval []
  {:start-date nil
   :end-date nil})
